var React = require('react');

function DocumentReadyIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.75 0.5C0.784766 0.5 0 1.28477 0 2.25V12.75C0 13.7152 0.784766 14.5 1.75 14.5H8.75C9.71523 14.5 10.5 13.7152 10.5 12.75V4.875H7C6.51602 4.875 6.125 4.48398 6.125 4V0.5H1.75ZM7 0.5V4H10.5L7 0.5ZM8.33984 8.18359L4.83984 11.6836C4.58281 11.9406 4.16719 11.9406 3.91289 11.6836L2.16016 9.93359C1.90313 9.67656 1.90313 9.26094 2.16016 9.00664C2.41719 8.75234 2.83281 8.74961 3.08711 9.00664L4.37227 10.2918L7.41016 7.25391C7.66719 6.99687 8.08281 6.99687 8.33711 7.25391C8.59141 7.51094 8.59414 7.92656 8.33711 8.18086L8.33984 8.18359Z"}));
}

DocumentReadyIcon.defaultProps = {"fill":"currentColor","viewBox":"0 0 11 15"};

module.exports = DocumentReadyIcon;

DocumentReadyIcon.default = DocumentReadyIcon;
